<div class="eui-picker-container" [class.eui-picker-container--disabled]="isDisabled" (click)="openModal()">
    <eui-chip-list [euiOutline]="isDisabled">
        <eui-chip *ngFor="let item of itemsState.selected">{{ item.label }}</eui-chip>
    </eui-chip-list>

    <eui-badge *ngIf="hasNbSelectedInfo" styleClass="eui-picker__nb-selected-badge" euiInfo euiSizeS>{{ itemsState.selected.length }} selected</eui-badge>
</div>
